module.exports = __webpack_public_path__ + "static/media/Dosis-SemiBold.cacdd7a5.ttf";